import { render, staticRenderFns } from "./assessorSummary.vue?vue&type=template&id=45fe7dd2&"
import script from "./assessorSummary.vue?vue&type=script&lang=js&"
export * from "./assessorSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports